function initPiPSimulation(options) {
      const {
          containerClass,
          pipButtonClass,
          pipModeClass,
          pipText,
          exitPipText
      } = options;
  
      console.log("initPiPSimulation");
  
      const videoContainer = document.querySelector(`.${containerClass}`);
      const pipButton = document.querySelector(`.${pipButtonClass}`);
      let isManualPiP = false; // Flag to track if PiP was manually triggered
      const maxWaitTime = 15000; // Maximum wait time in milliseconds (15 seconds)
      const intervalTime = 100; // Interval time in milliseconds (0.1 seconds)
      let elapsedTime = 0; // Time elapsed in milliseconds
  
      // Check for the video element in a loop every 0.1 seconds
      const checkVideoExistence = setInterval(() => {
          const video = videoContainer.querySelector('video');
          if (video) {
              console.log("Video Found");
              clearInterval(checkVideoExistence); // Stop checking once the video is found
  
              const videoOffsetTop = videoContainer.offsetTop;
              const videoHeight = videoContainer.offsetHeight;
  
              // Handle PiP mode toggle on button click
              pipButton.addEventListener('click', () => {
                  isManualPiP = true; // Set flag when user manually toggles PiP
                  togglePiP(videoContainer, pipButton, pipModeClass, pipText, exitPipText);
              });
  
              // Simulate PiP based on scroll position
              window.addEventListener('scroll', () => {
                  if (isManualPiP) return; // Skip scroll handling if PiP was manually triggered
  
                  const scrollPosition = window.scrollY;
  
                  if (scrollPosition > videoOffsetTop + videoHeight / 2 && !videoContainer.classList.contains(pipModeClass)) {
                      togglePiP(videoContainer, pipButton, pipModeClass, pipText, exitPipText);
                  } else if (scrollPosition <= videoOffsetTop + videoHeight / 2 && videoContainer.classList.contains(pipModeClass)) {
                      togglePiP(videoContainer, pipButton, pipModeClass, pipText, exitPipText);
                  }
              });
          } else {
              elapsedTime += intervalTime;
              if (elapsedTime >= maxWaitTime) {
                  console.warn("Video not found within 15 seconds. Stopping check.");
                  clearInterval(checkVideoExistence); // Stop checking if the video is not found after 15 seconds
              }
          }
      }, intervalTime); // Check every 100 milliseconds
  }
  
  // Toggles PiP mode on or off
  // Parameters:
  // - container: The container element for the video, used to toggle the PiP mode class.
  // - button: The button element that toggles PiP, updating its text content.
  // - pipModeClass: The CSS class that indicates PiP mode is active.
  // - pipText: The text to display on the button when PiP mode is inactive.
  // - exitPipText: The text to display on the button when PiP mode is active.
  function togglePiP(container, button, pipModeClass, pipText, exitPipText) {
      if (!container.classList.contains(pipModeClass)) {
          container.classList.add(pipModeClass);
          button.textContent = exitPipText;
      } else {
          container.classList.remove(pipModeClass);
          button.textContent = pipText;
      }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
      // Check screen width and initialize PiP simulation with appropriate classes
      const isDesktop = window.innerWidth >= 1024;
  
      initPiPSimulation({
          containerClass: isDesktop ? 'video-container.--desk' : 'video-container.--mob',
          pipButtonClass: isDesktop ? 'pip-button.--desk' : 'pip-button.--mob',
          pipModeClass: 'pip-mode',
          pipText: 'PiP',
          exitPipText: 'X'
      });
  });
  